import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer__brand">
        <span className="footer__wordmark">FLOURISH</span>
        <div className="footer__divider" />
        <span className="footer__sub">YOGA · ST. PETE</span>
      </div>
      <div className="footer__links">
        <Link to="/book">Book</Link>
        <a href="mailto:info@flourishyoga.studio">info@flourishyoga.studio</a>
        <a href="https://instagram.com" target="_blank" rel="noreferrer">Instagram</a>
      </div>
    </footer>
  );
}

export default Footer;
